import { CardHeader, Typography } from "@material-ui/core";
import { PeopleOutline } from "@material-ui/icons";
import { Grid, Paper } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import React from "react";
import AppDashBox from "./AppDashBox";

const AssociationResume = () => {
  return (
    <Grid pb={2} bgcolor="rgba(248, 248, 250, 1)">
      <Grid container spacing={1} mb={1}>
        <Grid item xs={12} md={4} lg={3}>
          <AppDashBox
            icon={
              <AssessmentOutlinedIcon color={"secondary"} fontSize="large" />
            }
            color={"primary"}
            label={"Teste"}
            value={"50"}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <AppDashBox color={"primary"} label={"Teste"} value={"50"} />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <AppDashBox color={"primary"} label={"Teste"} value={"50"} />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <AppDashBox color={"primary"} label={"Teste"} value={"50"} />
        </Grid>
      </Grid>
      <Grid container spacing={1} mb={1}>
        <Grid item xs={12} lg={9}>
          <Paper sx={{ height: 450, border: "1px solid #eee" }} elevation={0}>
            <CardHeader
              title="Statistique des associations"
              titleTypographyProps={{ variant: "subtitle1" }}
              sx={{ mb: -3 }}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Paper
            sx={{ height: 450, border: "1px solid #eee" }}
            elevation={0}
          ></Paper>
        </Grid>
      </Grid>
      <Grid container spacing={1} mb={0}>
        <Grid item xs={12} lg={6}>
          <Paper
            sx={{ height: 250, border: "1px solid #eee" }}
            elevation={0}
          ></Paper>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Paper
            sx={{ height: 250, border: "1px solid #eee" }}
            elevation={0}
          ></Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AssociationResume;
